import {useEffect} from "react";
import {useSuppliers} from "store/suppliers/supplier.store";
import {ISupplier, Roles} from "@evennt-tech/api-v2-core";
import {shallow} from "zustand/shallow";
import {useSelector} from "react-redux";
import {selectUser} from "store/auth/selectors";

type UseSupplierResult = [ISupplier | null, boolean, string | null];

const useSupplier = (id?: string): UseSupplierResult => {
  const {selected, isLoading, error, fetchOne, fetchOneByUserId} = useSuppliers(
    (s) => ({
      selected: s.selected,
      isLoading: s.isLoading,
      error: s.error,
      fetchOne: s.fetchOne,
      fetchOneByUserId: s.fetchOneByUserId,
    }),
    shallow
  );

  const {role, id: userId} = useSelector(selectUser);

  useEffect(() => {
    const supplierId = id || userId;
    if (!supplierId) return;

    if (id) {
      fetchOne({supplierId});
    } else if (role === Roles.SUPPLIER) {
      fetchOneByUserId({userId: supplierId});
    }
  }, [id, role, userId]);

  return [selected, isLoading, error];
};

export default useSupplier;
